export const SearchSimulations = () => {
    return <div>SearchSimulations</div>;
};
